import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={idx} className="flex items-center gap-2">
            {idx > 0 && (
              <span className="w-4 h-4 flex items-center justify-center text-foreground-700">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            )}
            {isLast ? (
              <span className="text-foreground-400 font-medium">{item.label}</span>
            ) : item.href ? (
              <Link
                to={item.href}
                className="text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-600">{item.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}